import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { MaintenancePage } from "@/components/MaintenancePage";

export function MaintenanceGate({ children }) {
  const { user, checking } = useAuth();
  const { pathname } = useLocation();
  const [maint, setMaint] = useState(null);

  useEffect(() => {
    let alive = true;
    api.get("/maintenance")
      .then(({ data }) => alive && setMaint(data))
      .catch(() => alive && setMaint({ active: false }));
    return () => { alive = false; };
  }, [pathname]);

  const isAdmin = user?.role === "admin";
  // Admins peuvent toujours se connecter / accéder à l'admin même en maintenance.
  const allowed = pathname === "/entrer" || pathname.startsWith("/admin");

  if (maint?.active && !isAdmin && !allowed && !checking) {
    return <MaintenancePage message={maint.message} />;
  }

  return (
    <>
      {maint?.active && isAdmin && (
        <div
          className="fixed top-0 inset-x-0 z-[120] bg-amber-500/90 text-black text-xs sm:text-sm font-semibold text-center py-1.5 px-4 flex items-center justify-center gap-2"
          data-testid="maintenance-admin-banner"
        >
          <AlertTriangle size={14} /> Mode maintenance ACTIF — seuls les admins voient le site.
        </div>
      )}
      {children}
    </>
  );
}
